"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Control_1 = __importDefault(require("ol/control/Control"));
class ProjectionControl extends Control_1.default {
    constructor(options) {
        super({
            element: options.element,
            target: options.target
        });
        const { supportedSRIDs, selectedSRID, switchProjAction } = options;
        const select = document.createElement('select');
        Object.keys(supportedSRIDs).forEach(srid => {
            const option = document.createElement('option');
            option.value = srid;
            option.text = supportedSRIDs[srid];
            option.selected = srid === selectedSRID;
            select.appendChild(option);
        });
        select.onchange = (ev => {
            switchProjAction(ev.target.value);
        });
        this.element.appendChild(select);
    }
}
exports.default = ProjectionControl;
